import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'userDefinedRole.new.error': {
    defaultMessage: 'Failed to create user-defined role',
    id: 'userDefinedRole.new.error'
  },
  'userDefinedRole.new.error.duplicate': {
    defaultMessage: 'A user-defined role with this name already exists',
    id: 'DUPLICATE_USER_DEFINED_ROLE'
  },
  'userDefinedRole.new.pageTitle': {
    defaultMessage: 'Create User-Defined Role',
    id: 'userDefinedRole.new.pageTitle'
  },
  'userDefinedRole.new.success': {
    defaultMessage: 'Created user-defined role',
    id: 'userDefinedRole.new.success'
  }
});
